import React from 'react';
import Utils from './Utils';
import { HashRouter, Route, Link, Routes } from 'react-router-dom'

import PageWrapper from './PageWrapper';
import { LowerContainer, LowerContainerBox } from './WelcomeScreen'; //TODO: put these in components
import { Nav, NavLink } from './PageWrapper';

import MixerLabAppsImage from './mixerlab_apps.jpeg';
import MixerLabDBsImage from './mixerlab_databases.jpeg';
import AdminManageUsers from './AdminManageUsers';


const AdminFAQ = () => {
  return (
    <LowerContainerBox style={{'marginTop': '0px'}}>
      <div className="faq-view__qa-item">
        <h2>What is MixerLab?</h2>
        <p>
          <li><b>MixerLab</b> is our internal data collection platform. Currently, we have three main apps.</li>
          <li><b>Actor</b> (actor.py): We collect human-to-human conversations via Actor Sessions and 
          collect human-to-bot conversations via Bot Sessions.</li>
          <li><b>Slack</b> (slack.py): We host data labeling tasks via the Slack API.</li>
          <li><b>Manager</b> (manager.py): We authenticate users with Google OAuth, manage users records with a PostgresSQL database, and pay them for tasks via PayPal.</li>
        </p>
        <h2>Actor Admin</h2>
        <p>
          <li>Here is where you can kick off and end an Actor Session and a Bot Session, and <a href="/actor/new_session_spec">write an Actor Session Spec</a> ...</li> 
          <li>... where you can provide example scenes and instructions to users acting as agents and callers or use LLM-generated scenes.</li>
          <li>Templates and more instructions can be found on the <a href="/actor/admin">Actor Admin</a> page.</li>
        </p>
        <h2>Slack Admin</h2>
        <p> 
          <li>Here is where you can view active and dormant labelling tasks and <a href="/slack/taskspec/">create a new labeling task</a>, which you can submit to Slack directly.</li> 
          <li>Templates and more instructions can be found on the <a href="/slack/">Slack Admin</a> page.</li>
        </p>
        <h2>Manage Users</h2>
        <p> 
          <li>You can view all users and manage the PostgresSQL database <a href="/admin/#/manage_users">here</a>.</li>
          {/* <img src={MixerLabDBsImage} style={{ width: '80%', height: 'auto' }}/> */}
        </p>
        <h2>Pay Users</h2>
        <p>
          <li>We pay users via PayPal and make bulk payments every two weeks. You can view the payment schedule and manage payments to users <a href="/admin/#/pay_users">here</a>.</li>
        </p> 
        <h2>Feel free to create your own app!</h2>
        <p>
          <li>Create <b>your_app.py</b> and a corresponding blueprint.</li>
          <li>Register <b>your_app_bp</b> in <b>app.py</b>.</li>
          <li>In <b>your_app.py</b>, use render_template to bring data from backend to frontend.</li>
          <li>Create corresponding <b>.html</b> files in the <b>templates</b> directory, where you specify the react elements.</li>
          <li>Create corresponding <b>.js</b> files in the <b>src</b> directory, where you define the react elements.</li>
          <li>Export the react elements in <b>index.js</b>.</li>
          <img src={MixerLabAppsImage} style={{ width: '50%', height: 'auto' }}/>
        </p>
      </div>
    </LowerContainerBox>
  )
}

const AdminPayment = () => {
  return(
    <div>
      <p>
      <li>We pay users via PayPal and make bulk payments every two weeks.</li>
      <li>Here is where you can view the payment schedule and manage payments to users.</li>
      <li>Click the following button to download a .csv file. <b>Please upload it to PayPal to pay users immediately</b>.</li> 
      <li>N. B. Upon clicking the button, the PostgresSQL database will be updated with each user's upcoming payment dollars added to their year-to-date payment and reset to 0.</li>
      </p>
      <button onClick={(e) => {window.location.href ='/admin/download_payment_csv'}}>Create Bulk Payment</button>
    </div>
  )
}



const Tab = () => (
  <Nav style={{'backgroundColor': 'transparent', 'textDecoration': 'none', 'justifyContent': 'space-evenly'}}>
    <Link style={{'paddingRight': '20px'}} to='/'>Home</Link>
    <Link style={{'paddingRight': '20px'}} to='/manage_users'>Manage Users</Link>
    <Link style={{'paddingRight': '20px'}} to='/pay_users'>Pay Users</Link>
  </Nav>
)

const Pane = () => {
  return (
    <Routes>
      <Route path='/' element={<AdminFAQ />}/>
      <Route path='/manage_users' element={<AdminManageUsers />}/>
      <Route path='/pay_users' element={<AdminPayment />}/>  {/* TODO: Add payment schedule and payment button to this page*/}
    </Routes>
  )
}

class AdminHome extends React.Component {
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
  }
  
  render() {
    return (
      <HashRouter hashType="noslash">
        <PageWrapper isAdmin={this.props.isAdmin} noContainer={true}>
          <LowerContainer>
            <Tab />
            <Pane />
          </LowerContainer>
        </PageWrapper>
      </HashRouter>
    );
  }
}

export default AdminHome;